import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-thunder-circle-icon',
  templateUrl: './code-thunder-circle.component.html'
})
export class CodeThunderCircleComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
